import React from "react";
import {StyledTooltip} from "../../pages/plan-inputs";
import {Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ErrorIcon from "@mui/icons-material/Error";

const ContributionSourceErrorCell = (props) => {
  const { dataItem } = props;
  const field = props.field || "";

  return (
    <td>
      {!dataItem[field] && (
      <div className="contribution-error-tooltip-wrapper">
        <StyledTooltip
            arrow
            className="error-tooltip"
            placement="right"
            title={
              <ul className="error-tooltip-ul">
                <li>
                  <Typography
                      className={'default-font'}
                      textAlign={'left'}
                      variant={'span'}>
                    Please create an income to cover the current income contribution period.
                  </Typography>
                </li>
              </ul>
            }
        >
          <IconButton>
            <ErrorIcon />
          </IconButton>
        </StyledTooltip>
      </div>
      )}
    </td>
  );
};

export default ContributionSourceErrorCell;
